import { useAppContext } from '../contexts/AppContext';

interface ProtectedPageOptions {
  requireFirma?: boolean;
  requireYil?: boolean;
  loadingMessage?: string;
  errorMessage?: string;
}

export const useProtectedPage = (options: ProtectedPageOptions = {}) => {
  // Merkezi AppContext'ten tüm koruma mantığını al
  const { isReady, renderGuard, selectedFirma, selectedYil, isLoading } = useAppContext();
  
  // Opsiyonlar şimdilik kullanılmıyor, gelecekte özelleştirme için saklanıyor
  const {
    requireFirma = true,
    requireYil = true,
    loadingMessage = 'Yükleniyor...',
    errorMessage = 'Firma ve yıl seçimi gerekli'
  } = options;

  return {
    isReady,
    renderGuard,
    selectedFirma,
    selectedYil,
    isLoading
  };
};